/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { rfqRequestQuotePageContainerStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuotePageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

// xng-chane: just removing code section from one of the breakpoints (all this code is OOTB)
rfqRequestQuotePageContainerStyles.container = {
    css: css`
        /* stylelint-disable value-no-vendor-prefix */
        display: -ms-grid;
        display: grid;
        padding: 1.5rem 0 0 1.5rem;
        margin: -1.5rem;
        overflow: hidden;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        grid-template-columns: minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 1fr);
                    `,
                    null,

                    css`
                        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 2fr) minmax(0, 1fr);
                    `,
                ],
                "min",
            )}
    `,
};
